// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_EMPLOYEE_SALARY_SHEET, EMPLOYEE_SALARY_SHEET, EDIT_EMPLOYEE_SALARY_SHEET, GET_EMPLOYEE_SALARY_SHEET, DELETE_EMPLOYEE_SALARY_SHEET } from '../../../../common/constant'

export const actionEmployeeSalarySheet = createAsyncThunk('appEmployeeSalarySheet/actionEmployeeSalarySheet', async (params, thunkAPI) => {
    return await post(EMPLOYEE_SALARY_SHEET, params, thunkAPI)
})

export const actionAddEmployeeSalarySheet = createAsyncThunk('appEmployeeSalarySheet/actionAddEmployeeSalarySheet', async (params, thunkAPI) => {
    return await put(ADD_EMPLOYEE_SALARY_SHEET, params, thunkAPI)
})

export const actionGetEmployeeSalarySheet = createAsyncThunk('appEmployeeSalarySheet/actionGetEmployeeSalarySheet', async (params, thunkAPI) => {
    return await post(GET_EMPLOYEE_SALARY_SHEET, params, thunkAPI)
})

export const actionEditEmployeeSalarySheet = createAsyncThunk('appEmployeeSalarySheet/actionEditEmployeeSalarySheet', async (params, thunkAPI) => {
    return await post(EDIT_EMPLOYEE_SALARY_SHEET, params, thunkAPI)
})

export const actionDeleteEmployeeSalarySheet = createAsyncThunk('appEmployeeSalarySheet/actionDeleteEmployeeSalarySheet', async (params, thunkAPI) => {
    return await post(DELETE_EMPLOYEE_SALARY_SHEET, params, thunkAPI)
})

export const appEmployeeSalarySheetSlice = createSlice({
    name: 'appEmployeeSalarySheet',
    initialState: {
        //list
        loading: false,
        employeeSalarySheet: null,

        //add
        loadingAdd: false,
        addEmployeeSalarySheet: null,

        //get
        loadingGet: false,
        getEmployeeSalarySheet: null,

        //edit
        loadingEdit: false,
        editEmployeeSalarySheet: null,

        //delete
        loadingDelete: false,
        deleteEmployeeSalarySheet: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetEmployeeSalarySheetResponse: (state) => {
            state.employeeSalarySheet = null
        },
        resetAddEmployeeSalarySheetResponse: (state) => {
            state.addEmployeeSalarySheet = null
        },
        resetGetEmployeeSalarySheetResponse: (state) => {
            state.getEmployeeSalarySheet = null
        },
        resetEditEmployeeSalarySheetResponse: (state) => {
            state.editEmployeeSalarySheet = null
        },
        resetDeleteEmployeeSalarySheetResponse: (state) => {
            state.deleteEmployeeSalarySheet = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionEmployeeSalarySheet.pending, (state) => {
                state.loading = true
            })
            .addCase(actionEmployeeSalarySheet.fulfilled, (state, action) => {
                state.loading = false
                state.employeeSalarySheet = action.payload
            })
            .addCase(actionEmployeeSalarySheet.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddEmployeeSalarySheet.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddEmployeeSalarySheet.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addEmployeeSalarySheet = action.payload
            })
            .addCase(actionAddEmployeeSalarySheet.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetEmployeeSalarySheet.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetEmployeeSalarySheet.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getEmployeeSalarySheet = action.payload
            })
            .addCase(actionGetEmployeeSalarySheet.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditEmployeeSalarySheet.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditEmployeeSalarySheet.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editEmployeeSalarySheet = action.payload
            })
            .addCase(actionEditEmployeeSalarySheet.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteEmployeeSalarySheet.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteEmployeeSalarySheet.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteEmployeeSalarySheet = action.payload
            })
            .addCase(actionDeleteEmployeeSalarySheet.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetEmployeeSalarySheetResponse, resetAddEmployeeSalarySheetResponse, resetGetEmployeeSalarySheetResponse, resetEditEmployeeSalarySheetResponse, resetDeleteEmployeeSalarySheetResponse } = appEmployeeSalarySheetSlice.actions

export default appEmployeeSalarySheetSlice.reducer